import type { IonRefresherCustomEvent } from '@ionic/core';
import { IonRefresher, IonRefresherContent } from '@ionic/react';

export type OnRefresh = () => Promise<unknown>;

type RefresherProps = {
  onRefresh: OnRefresh;
};

export const Refresher = ({ onRefresh }: RefresherProps) => {
  const handleRefresh = async (event: IonRefresherCustomEvent<unknown>) => {
    await onRefresh();
    event.target.complete();
  };

  return (
    <IonRefresher slot="fixed" onIonRefresh={handleRefresh} pullMin={60} pullMax={500}>
      <IonRefresherContent
        className="text-sm"
        pullingIcon={null}
        pullingText="Zum Aktualisieren loslassen"
        refreshingSpinner="lines-small"
      />
    </IonRefresher>
  );
};
